import { Box, Icon, TokensIcon } from '@bonanza-social/moonlight';
import { PromosBadgeListProps } from './PromosBadgeList.types';
import { memo, useMemo } from 'react';
import { rewardBadgeMap } from './PromosBadgeList.constants';
import { selectTokenIconSmall, useSelector } from '@bonanza-social/toolkit/state';
import PromoBadge from './PromoBadge/PromoBadge';

function PromosBadgeList({ rewards }: PromosBadgeListProps) {
  const filteredRewards = useMemo(
    () => rewards.filter((reward) => reward.rewardAmount > 0),
    [rewards],
  );
  const tokenIcon = useSelector(selectTokenIconSmall);

  return (
    <Box flexDirection="row" gap="space-200">
      {filteredRewards.map((reward, i) => {
        const iconName = rewardBadgeMap[reward.rewardTarget];

        return (
          <Box key={i}>
            {iconName && (
              <PromoBadge amount={reward.rewardAmount}>
                <Icon
                  name={iconName}
                  gradient="accentBackground"
                  width="space-500"
                  height="space-500"
                />
              </PromoBadge>
            )}
            {reward.rewardTarget === 'Tokens' && (
              <PromoBadge amount={reward.rewardAmount}>
                <TokensIcon
                  {...tokenIcon}
                  width="space-500"
                  height="space-500"
                />
              </PromoBadge>
            )}
          </Box>
        );
      })}
    </Box>
  );
}

export default memo(PromosBadgeList);
